import React from 'react'
import componentStyles from './Modal.module.scss'
import classnames from 'classnames'
import { ModalHeaderProps, ModalBodyProps, ModalFooterProps, ModalProps } from './types'

class ModalHeader extends React.PureComponent<ModalHeaderProps> {

  render () {

    const headerClasses = classnames(
      componentStyles[`modal__header`], {
        [componentStyles[`modal--no-border`]]: this.props.hideBorder || false
      },
      this.props.headerClasses,
      this.props.className
    )

    return (
      <div className={headerClasses} data-bdd="modal-header">
        <div
          className={classnames(componentStyles[`modal__title`], this.props.headerTitleClass)}
          data-bdd={this.props.dataBdd || 'modal-title'}
        >
          {this.props.children}
        </div>
      </div>
    )

  }

}

class ModalBody extends React.PureComponent<ModalBodyProps> {

  render () {

    const bodyClasses = classnames(
      componentStyles[`modal__body`],
      this.props.className
    )

    return <div
      className={bodyClasses}
      data-bdd={this.props.dataBdd || 'modal-body'}
    >
      {this.props.children}
    </div>

  }

}

class ModalFooter extends React.PureComponent<ModalFooterProps> {

  render () {

    const footerClasses = classnames(
      componentStyles[`modal__footer`], {
        [componentStyles[`modal--no-border`]]: this.props.hideBorder || false
      },
      this.props.className
    )

    return <div
      className={footerClasses}
      data-bdd={this.props.dataBdd || 'modal-footer'}
    >
      {this.props.children}
    </div>

  }

}

export default class Modal extends React.Component<ModalProps> {

  static Header = ModalHeader
  static Body = ModalBody
  static Footer = ModalFooter

  constructor (props) {

    super(props)
    this.onClickOutside = this.onClickOutside.bind(this)

  }

  onClickOutside = (event, containerClasses) => {

    if (this.props.onClickOutside && event.target.className === containerClasses) {

      this.props.onClickOutside()

    }

  }

  render () {

    const { backdrop = true, isWhiteBackdrop, isLightBackdrop, isLightGrayBackdrop, containerClass = '' } = this.props

    const modalClasses = classnames(componentStyles[`modal`], {
      [componentStyles['modal--open']]: this.props.isOpen || false
    })

    const containerClasses = classnames(
      componentStyles[`modal__background`], containerClass, {
        [componentStyles['modal--open']]: this.props.isOpen || false,
        [componentStyles['modal--centered']]: this.props.centered || true,
        [componentStyles['modal--end']]: this.props.end || false
      }
    )

    const dialogClasses = classnames(
      componentStyles[`modal__dialog`], {
        [componentStyles[`modal--concise`]]: this.props.concise || false
      },
      this.props.dialogClassName
    )

    const contentClasses = classnames(componentStyles[`modal__content`], {
      [componentStyles[`--transparent`]]: this.props.transparent || false,
      [componentStyles[`modal--no-border`]]: this.props.hideBorder || false
    })

    const backdropClasses = classnames({
      [componentStyles['modal__backdrop']]: backdrop,
      [componentStyles['modal__backdrop__white']]: backdrop && isWhiteBackdrop,
      [componentStyles['modal__backdrop__light']]: backdrop && isLightBackdrop,
      [componentStyles['modal__backdrop__light__gray']]: backdrop && isLightGrayBackdrop
    })

    return (
      <div className={modalClasses} data-bdd={this.props.dataBdd}>
        <div className={containerClasses} onClick={(e) => this.onClickOutside(e, containerClasses)}>
          <div className={dialogClasses} data-bdd="modal-dialog">
            <div className={`${contentClasses} ${this.props.className || ''}`} data-bdd="modal-content">
              {this.props.children}
            </div>
          </div>
        </div>
        <div className={backdropClasses} style={{ opacity: this.props.backgroundOpacity || 1 }} data-bdd="modal-backdrop" />
      </div>
    )

  }

}
